import { Translator } from 'Translator';
import { SubOption } from 'model/Filters';

const activityTypeSubOptions = [
  {
    id: 11,
    name: Translator.translate(
      'UserEnvironment.Filters.tours',
      {},
      true,
      'Tours',
    ),
    value: 'tours',
  },
  {
    id: 12,
    name: Translator.translate(
      'UserEnvironment.Filters.activities',
      {},
      true,
      'Activities',
    ),
    value: 'activities',
  },
] as SubOption[];

export default activityTypeSubOptions;
